import { render, staticRenderFns } from "./orderForEvent.vue?vue&type=template&id=03ad4664&"
import script from "./orderForEvent.vue?vue&type=script&lang=js&"
export * from "./orderForEvent.vue?vue&type=script&lang=js&"
import style0 from "./orderForEvent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports